import { css } from '@emotion/react';
import React from 'react';

import CustomLink from '@/src/shared/components/Link';

import HeaderSection from '../HeaderSection';
import ContactListsItems from './components/ContactListItems';

const styles = {
  contactListsContainer: css`
    padding: 2.6rem 2.4rem;
  `,
};

function ContactLists({ user }) {
  const accountManagerName = user.AccountManager;
  const accountManagerEmail = (
    <CustomLink href={`mailto:${user.AccountManagerEmail}`}>{user.AccountManagerEmail}</CustomLink>
  );
  return (
    <div css={styles.contactListsContainer}>
      <HeaderSection headerText="My Contact Lists" />
      {accountManagerName !== '' && (
        <p>
          You are signed up to receive emails from the following lists. To manage your contact list,
          please contact your Account Manager, {accountManagerName}, at {accountManagerEmail}.
        </p>
      )}
      <ContactListsItems contactLists={user.ContactLists} />
    </div>
  );
}

export default ContactLists;
